import { Injectable } from '@angular/core';
import {TaxRoundingType, EffectiveTaxRate } from '@ordering/utilties/enums/tax-calculator.utility';
import {TaxRatesEntity, LocationsEntity } from '@core/redux/stores';
import * as moment from 'moment-timezone';
@Injectable()
export class TaxCalculatorService {
  CalculateTax(amount: number, taxRate: number, taxRoundingType: TaxRoundingType) {
      if (taxRoundingType === TaxRoundingType.FloridaPennyTables) {
          return this.CalculateFloridaTax(amount, taxRate);
      } else {
          let taxAmount = amount * (taxRate / 100);
           taxAmount = this.CompensateForFloat(taxAmount);
          return this.Round(taxAmount, 2, taxRoundingType);
      }
  }

  calculateTaxRate(locationsEntity: LocationsEntity): TaxRatesEntity {
    if (locationsEntity && locationsEntity.taxRates && locationsEntity.taxRates.length) {
        const taxRates = locationsEntity.taxRates;
    const localDate = new Date();
    const utcDate = localDate.toUTCString();
    const currentDate = new Date(utcDate);
    let lessTax: TaxRatesEntity;
        let greatertax: TaxRatesEntity;
    let lessindex  = 0;
    let greaterindex = 0;
    // let taxRate = 0;
    taxRates.forEach((obj, i) => {
      const date = new Date(obj.effectiveUtc);
      if (moment(date).isAfter(currentDate)) {
          lessTax = obj;
          lessindex = i;
      } else if (moment(date).isBefore(currentDate)) {
        greatertax = obj;
        greaterindex = i;
      }
      // index = i;

    });
    // let taxRate : TaxRatesEntity;
    if (lessTax && !greatertax) {
      return lessTax;
    }
    if (!lessTax && greatertax) {
      return greatertax;
    }
    if (lessTax.taxRate > greatertax.taxRate) {
      // taxRate = taxRates.find(;
      return lessTax;

    } else {
      // = greatertax;
      return greatertax;
    }
  } else if (locationsEntity) {
      const taxRateEntity = new TaxRatesEntity();
      taxRateEntity.taxRate = locationsEntity.taxPercentage * 100;
      taxRateEntity.taxRoundingType = TaxRoundingType.RoundAwayFromZero;
      return taxRateEntity;
  }
}

  CalculateFloridaTax(amount: number, taxRate: number) {
      // Implements sales tax logic to conform to tables:
      // http://floridarevenue.com/Forms_library/current/dr2x.pdf

      const wholeDollarAmount: number = Math.floor(amount);
      const pennyAmount: number = Math.round((amount - wholeDollarAmount) * 100);
      const taxAmount: number = amount * (taxRate / 100);
      const wholeDollarAmountIsEven: boolean = ((wholeDollarAmount % 2) === 0);
      const taxRateIsWholeNumber: boolean = ((Math.round(taxRate * 10) % 10) === 0);


      if ((1 <= pennyAmount && pennyAmount <= 9) && (taxRateIsWholeNumber || wholeDollarAmountIsEven)) {
          // Math.floor is only used when the penny amount is between 0.01 and 0.09
          // If the tax rate is 6.5% or 7.5%, then it also only uses floor on the even whole dollar amounts.
          return this.RoundFloor(taxAmount, 2);
      } else {
          return this.RoundCeiling(taxAmount, 2);
      }
  }

  Round(amount: number, decimals: number, taxRoundingType: TaxRoundingType) {
      switch (taxRoundingType) {
          case TaxRoundingType.RoundAwayFromZero:
              return this.RoundAwayFromZero(amount, decimals);
          case TaxRoundingType.RoundToEven:
              return this.RoundToEven(amount, decimals);
          case TaxRoundingType.Ceiling:
              return this.RoundCeiling(amount, decimals);
          case TaxRoundingType.Floor:
              return this.RoundFloor(amount, decimals);
          case TaxRoundingType.TaxIncluded:
              return 0;
          default:
              return this.RoundAwayFromZero(amount, decimals);
      }
  }

  IsTaxIncluded(taxRoundingType: TaxRoundingType) {
    switch (taxRoundingType) {
      case TaxRoundingType.TaxIncluded:
        return true;
      default:
        return false;
    }
  }

  RoundAwayFromZero(amount: number, decimals: number) {
      const multiplier: number = Math.pow(10, decimals);
      let result: number = amount * multiplier;
      result = this.CompensateForFloat(result);

      // Accounts for different rounding logic in C#
      const sign = amount > 0 ? 1 : -1;
      result = Math.abs(result);
      result = Math.round(result) * sign;
      result = result / multiplier;
      return result;
  }

  RoundToEven(amount: number, decimals: number) {
      const multiplier: number = Math.pow(10, decimals);

      let result: number = amount * multiplier;
      result = this.CompensateForFloat(result);

      const sign = amount > 0 ? 1 : -1;
      const wholeNumber = Math.abs(Math.floor(result));
      const decimal = Math.abs(result) - wholeNumber;

      if ((decimal === 0.5) && (wholeNumber % 2 === 0)) {
          result = wholeNumber * sign;
      } else {
          result = Math.round(result);
      }
      result = result / multiplier;
      return result;
  }

  RoundCeiling(amount: number, decimals: number) {
      const multiplier: number = Math.pow(10, decimals);
      let result: number = amount * multiplier;
      result = this.CompensateForFloat(result);
      result = Math.ceil(result);
      result = result / multiplier;
      return result;
  }

  RoundFloor(amount: number, decimals: number) {
      const multiplier: number = Math.pow(10, decimals);
      let result: number = amount * multiplier;
      result = this.CompensateForFloat(result);
      result = Math.floor(result);
      result = result / multiplier;
      return result;
  }

  CompensateForFloat(amount: number) {
      // Floating point causes rounding errors, but usually well past the 7th digit.
      // Using this, it passed 5.4 million test cases.
      const maxDecimals = 7;
      const decimal: string = (Math.abs(amount) % 1).toString();
      if (decimal.length > (maxDecimals + 2)) {
          return this.RoundAwayFromZero(amount, maxDecimals);
      } else {
          return amount;
      }
  }
}
